import PageOrPost from './[slug]'

export default PageOrPost
